import { INT_MAX_SIGNED_32_BIT_VALUE } from '../../../../globals/globals';

export class SignStickerType {
  constructor(readonly label: string, readonly value: number) {}
}

export const SIGN_STICKER_TYPE_CHOICES = {
  WHITE: new SignStickerType('Wit', 0),
  BLACK: new SignStickerType('Zwart', 1),
  YELLOW: new SignStickerType('Geel', 2),
  RED: new SignStickerType('Rood', 3),
  CUSTOM: new SignStickerType('Custom', INT_MAX_SIGNED_32_BIT_VALUE)
};

export const SIGN_STICKER_TYPE_CHOICES_ARRAY = Object.values(
  SIGN_STICKER_TYPE_CHOICES
);
